export interface InstanceFeatureProperties {
    [key: string]: unknown;
    id?: string | number;
    joined?: boolean;
}

export function isFeatureCollection(data: GeoJSON.GeoJSON): data is GeoJSON.FeatureCollection {
    const obj = data as { features?: unknown; type?: string };
    return obj.type === 'FeatureCollection' && Array.isArray(obj.features);
}
